import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SecurityService } from '../services/security.service';
import { PinValidationService } from '../services/pin-validation.service';

@Component({
    selector: 'app-welcome',
    templateUrl: './welcome.component.html',
    styleUrls: ['./welcome.component.scss'],
    standalone: false
})
export class WelcomeComponent implements OnInit {
  showWelcomeComponent: boolean = true;
  showCreateComponent: boolean = true;

  constructor(
    private router: Router,
    private securityService: SecurityService,
    private pinValidationService: PinValidationService
  ) {}
  
  ngOnInit(): void {
    // Envía un mensaje al parent cuando se carga el componente
    if (window.parent !== window) {
      window.parent.postMessage({ status: 'loaded', url: window.location.href }, '*');
    }
  }
  onLoginClick() {
    const token = this.securityService.getToken();
    const isPinValidated = this.securityService.getPinValidationStatus();

    if (token && !this.securityService.isTokenExpired() && isPinValidated) {
      this.router.navigate(['/my-portals']);
      return;
    }
    
    // Si no hay sesión activa, redirigir al login
    this.router.navigate(['/login']);
  }
  goHome() {
    this.router.navigate(['/']);
  }
  onSignUp(){
    this.router.navigate(["/create"]); 
  }

 
  
}
